import { render, staticRenderFns } from "./activityResultForm.vue?vue&type=template&id=3a10ec2f"
import script from "./activityResultForm.vue?vue&type=script&lang=js"
export * from "./activityResultForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports